import React from 'react';
import {
  AddToShoppingCartSource,
  IPrismicRichText,
  ISearchProduct,
} from '@monofront/types';
import { useInfiniteHits } from 'react-instantsearch-core';
import { Hit } from 'instantsearch.js';
import CarouselProducts from '@components/CarouselProducts';
import Link from 'next/link';
import { RichText } from 'prismic-reactjs';
import { useTranslations } from 'next-intl';

type Hits = {
  customSort: (value: Array<Hit<ISearchProduct>>) => Array<Hit<ISearchProduct>>;
  title: IPrismicRichText;
  position: number;
  blockName?: string;
};

const Hits: React.FC<Hits> = ({ customSort, position, blockName, title }) => {
  const { hits } = useInfiniteHits<ISearchProduct>();
  const tCatalog = useTranslations('Catalog');

  if (hits.length === 0) {
    return null;
  }

  return (
    <>
      <CarouselProducts
        headerTitle={
          <div className="header">
            <div className="title">
              <RichText render={title} />
              <div className="link-container">
                <Link href="/pages/my-lists?tab=my-purchases" legacyBehavior>
                  <a className="tw-lf-link-md tw-whitespace-nowrap">
                    <span> {tCatalog('seeAll')}</span>
                  </a>
                </Link>
              </div>
            </div>
          </div>
        }
        products={customSort(hits)}
        containerContext={{
          source: AddToShoppingCartSource.CAROUSEL,
          widgetName: blockName,
          widgetPosition: position ? `${position}` : undefined,
        }}
      />
      <style jsx>{`
        .header {
          display: flex;
          flex-direction: column;
          margin-bottom: var(--space-4);
        }

        .title {
          display: flex;
          justify-content: space-between;
          width: 100%;
        }

        .link-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: var(--space-2);
        }
      `}</style>
    </>
  );
};

export default Hits;
